import { getAbTestV2 } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const PDP_RecentFavesMostSaved_Feb2026 = 'PDP_RecentFavesMostSaved_Feb2026';

export const isRecentlyFavoritedPdpVariant = (): boolean =>
    getAbTestV2(PDP_RecentFavesMostSaved_Feb2026)?.variant === 'variant';
